/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TypeDocumentation,
    TypeDocumentationFromJSON,
    TypeDocumentationFromJSONTyped,
    TypeDocumentationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ArgumentType
 */
export interface ArgumentType {
    /**
     * 
     * @type {string}
     * @memberof ArgumentType
     */
    readonly displayName: string;
    /**
     * 
     * @type {Array<TypeDocumentation>}
     * @memberof ArgumentType
     */
    readonly documentation: Array<TypeDocumentation>;
}

export function ArgumentTypeFromJSON(json: any): ArgumentType {
    return ArgumentTypeFromJSONTyped(json, false);
}

export function ArgumentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArgumentType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': json['display_name'],
        'documentation': ((json['documentation'] as Array<any>).map(TypeDocumentationFromJSON)),
    };
}

export function ArgumentTypeToJSON(value?: ArgumentType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


